import React from "react";
function Guardian({ guardian }: { guardian: string }) {
  return <p className="">{guardian}</p>;
}

export default Guardian;
